import React, { useCallback, useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BadgeCheck, MapPin, X } from 'lucide-react';
// Nombres y lugares de Argentina para la prueba social.
const NAMES = ['Martín G.', 'Lucía F.', 'Sofía R.', 'Mateo P.', 'Valentina S.', 'Joaquín M.', 'Camila D.', 'Tomás L.', 'Julieta A.', 'Agustín B.', 'Florencia C.', 'Nicolás V.', 'Brenda T.', 'Federico N.', 'Rocío E.', 'Santiago O.', 'Carla M.', 'Lautaro H.', 'Micaela Q.', 'Gonzalo R.'];
const PLACES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'San Miguel de Tucumán', 'Salta', 'Santa Fe', 'San Juan', 'Neuquén', 'Resistencia', 'Bahía Blanca', 'Posadas', 'Quilmes', 'Lanús', 'Avellaneda', 'San Luis', 'Paraná', 'Bariloche'];
const OFFERS = ['la Edición Completa', 'la Edición Base'];
interface Sale {
  name: string;
  place: string;
  offer: string;
  minutesAgo: number;
}
const rand = (min: number, max: number) => Math.floor(Math.random() * (max - min + 1)) + min;
const pick = <T,>(arr: T[]): T => arr[Math.floor(Math.random() * arr.length)];
function makeSale(): Sale {
  return {
    name: pick(NAMES),
    place: pick(PLACES),
    offer: pick(OFFERS),
    minutesAgo: rand(2, 18)
  };
}
export function SalesNotification() {
  const [sale, setSale] = useState<Sale | null>(null);
  const [visible, setVisible] = useState(false);
  const hideTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const nextTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
  const dismissed = useRef(false);
  const scheduleHide = useCallback(() => {
    // Cada popup queda visible ~5.5s antes de ocultarse.
    hideTimer.current = setTimeout(() => setVisible(false), 5500);
  }, []);
  const showNext = useCallback(() => {
    if (dismissed.current) return;
    setSale(makeSale());
    setVisible(true);
    scheduleHide();
  }, [scheduleHide]);
  // Tras ocultarse, programa el siguiente popup en 40-60s.
  useEffect(() => {
    if (visible || dismissed.current) return;
    nextTimer.current = setTimeout(() => showNext(), rand(40000, 60000));
    return () => {
      if (nextTimer.current) clearTimeout(nextTimer.current);
    };
  }, [visible, showNext]);
  // Primer popup a los ~8s de cargar la página.
  useEffect(() => {
    const first = setTimeout(() => showNext(), 8000);
    return () => {
      clearTimeout(first);
      if (hideTimer.current) clearTimeout(hideTimer.current);
      if (nextTimer.current) clearTimeout(nextTimer.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleClose = () => {
    dismissed.current = true;
    setVisible(false);
    if (hideTimer.current) clearTimeout(hideTimer.current);
    if (nextTimer.current) clearTimeout(nextTimer.current);
  };
  return <div className="fixed bottom-24 left-4 right-4 sm:left-4 sm:right-auto z-40 pointer-events-none" data-id="element-232">
      <AnimatePresence data-id="element-233">
        {visible && sale && <motion.div initial={{
        opacity: 0,
        y: 24,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 24,
        scale: 0.95
      }} transition={{
        type: 'spring',
        stiffness: 320,
        damping: 26
      }} role="status" aria-live="polite" className="pointer-events-auto relative w-full sm:w-[340px] flex items-center gap-3 rounded-2xl border border-brand-gold/30 bg-brand-panel/95 backdrop-blur-md px-3.5 py-3 shadow-[0_12px_40px_rgba(0,0,0,0.55)]" data-id="element-234">
            <span className="flex-shrink-0 w-10 h-10 rounded-full bg-brand-gold/15 border border-brand-gold/40 flex items-center justify-center" data-id="element-235">
              <BadgeCheck className="w-5 h-5 text-brand-gold" data-id="element-236" />
            </span>

            <div className="flex-1 min-w-0" data-id="element-237">
              <p className="text-[10px] font-bold uppercase tracking-wider text-brand-gold" data-id="element-238">
                ✓ Compra verificada
              </p>
              <p className="text-sm text-white leading-snug" data-id="element-239">
                <span className="font-bold" data-id="element-240">{sale.name}</span> acaba de comprar{' '}
                <span className="text-brand-gold font-semibold" data-id="element-241">
                  {sale.offer}
                </span>
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-[11px] text-gray-400" data-id="element-242">
                <MapPin className="w-3 h-3" data-id="element-243" />
                {sale.place} · hace {sale.minutesAgo} min
              </p>
            </div>

            <button type="button" onClick={handleClose} aria-label="Cerrar notificación" className="absolute top-2 right-2 text-gray-500 hover:text-white transition-colors" data-id="element-244">
              <X className="w-3.5 h-3.5" data-id="element-245" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}